import Modal from "modal-vanilla";
import { GetDemoVersionModalComponent } from "../components/modals/get-demo-version-modal.component";

export class HomePage {

  _applicationType = ['TV', 'STREAMING', 'RADIO', 'SOCIAL_MEDIA'];
  _applicationTypeElements;
  _appsTypeModuleElements;
  _applicationTypeMobileElements;
  _activeAppsIndex = 0;
  _intervalAnimation;
  _appsTile;

  constructor() {
  }

  init() {
    this.demoVersionBtnActions();
    this.checkNewsletterModal();
    this._applicationTypeElements = Array.from(document.querySelectorAll('.information__app'));
    this._applicationTypeMobileElements = Array.from(document.querySelectorAll('.apps__item'));
    this._appsTypeModuleElements = Array.from(document.querySelectorAll('.apps__modules__tile'));
    this._appsTile = Array.from(document.querySelectorAll('.information__app, .apps__item'));

    if (this._appsTile.length) {
      for (let i = 0; i < this._appsTile.length; i++) {
        this._appsTile[i].addEventListener('click', this.changeSelectedApp.bind(this))
      }

    }

    if (this._applicationTypeElements.length > 0 && this._appsTypeModuleElements.length > 0
      && this._applicationTypeMobileElements.length > 0) {
      this.activeAnimation();
    }
  }

  checkNewsletterModal() {
    if (window.location.href.includes('#newsletterconfirmation')) {
      const newsletterConfirmationModalEl = document.querySelector('.home-page-wrapper #newsletter-confirmation-modal');

      if (newsletterConfirmationModalEl) {
        const urlParams = new URLSearchParams(window.location.search);
        const senderEmail = urlParams.get('senderEmail');

        if (senderEmail) {
          window.history.replaceState({}, document.title, window.location.pathname);

          fetch(`https://api-website.createctrl.cloud/api/v1/emails/newsletter/confirm?senderEmail=${senderEmail}`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
          })
          .then(() => {
            console.log('Successfully confirmed newsletter');
            this._newsletterConfirmationModalInstance = new Modal({
              el: newsletterConfirmationModalEl
            }).show();
          })
          .catch(error => {
            console.error('Błąd podczas wywoływania API:', error);
          });
        }
      } 
    }
  }

  activeAnimation() {
    this._intervalAnimation = setInterval(this.animateModulesAndAps.bind(this), 4.8 * 1000)

  }

  demoVersionBtnActions() {
    this._demoVersionBtnEl = document.querySelector('.home-page-wrapper .demo-version-modal-btn');
    this._demoVersionModalEl = document.querySelector('.home-page-wrapper #get-demo-version-modal');

    this.openDemoVersionModal();
  }

  animateModulesAndAps() {
    const activeApps = this._applicationType[this._activeAppsIndex];
    if (outerWidth < 744) {
      this._applicationTypeMobileElements.forEach((item) => {
        const { dataset: { type } } = item
        const currentIndex = this._activeAppsIndex + 1 === 4 ? 0 : this._activeAppsIndex + 1
        item.classList[type === this._applicationType[currentIndex] ? 'add' : 'remove']('apps__item--selected');

        const { parentElement } = item
        if (this._applicationType[currentIndex] === 'SOCIAL_MEDIA') {
          parentElement.scrollLeft += 41;
        } else {
          parentElement.scrollLeft -= 41;
        }
      })
    }

    this._appsTypeModuleElements.forEach((item) => {

      item.classList.remove('apps__modules__tile--active');
      item.classList.add('apps__modules__tile--inactive');

      setTimeout(() => {
        item.classList.add('d-none')
        if (item.dataset.type.includes(this._applicationType[this._activeAppsIndex])) {
          item.classList.remove('apps__modules__tile--inactive');
          item.classList.remove('d-none')
          setTimeout(() => {
            item.classList.add('apps__modules__tile--active');
          }, 10)
        } else {
          item.classList.remove('apps__modules__tile--active');
          item.classList.add('apps__modules__tile--inactive');
        }
      }, 600)

    })


    this._applicationTypeElements.find((item) => {
      return item.dataset.type === activeApps
    }).classList.add('information__app--inactive')

    this._applicationTypeElements.find((item) => {
      return item.dataset.type === this._applicationType[this._activeAppsIndex + 1 === 4 ? 0 : this._activeAppsIndex + 1]
    }).classList.remove('information__app--inactive')


    this._activeAppsIndex = this._activeAppsIndex === 3 ? 0 : this._activeAppsIndex + 1;

  }

  openDemoVersionModal() {
    if (this._demoVersionModalEl && this._demoVersionBtnEl) {
      const getDemoVersionModalComponent = new GetDemoVersionModalComponent();
      getDemoVersionModalComponent.init();

      this._demoVersionBtnEl.addEventListener('click', () => {
        this._applyForJobModalInstance = new Modal({
          el: this._demoVersionModalEl
        }).show();

        this._applyForJobModalInstance.on('dismiss', function (myModal, event) {
          if (getDemoVersionModalComponent.formSent) {
            getDemoVersionModalComponent.reload();
          }
        });
      });
    }
  }

  changeSelectedApp({ currentTarget }) {

    const selectedAppIndex = this._applicationType
      .findIndex((item) => item === currentTarget.dataset.type)

    if (selectedAppIndex !== this._activeAppsIndex) {

      const currentActiveTile = document.querySelectorAll('.information__app:not(.information__app--inactive)');
      currentActiveTile.forEach((item) => {
        item.classList.add('information__app--inactive');
      })

      clearInterval(this._intervalAnimation);
      this._intervalAnimation = null;
      this._activeAppsIndex = selectedAppIndex === 0 ? 3 : selectedAppIndex - 1;
      this.animateModulesAndAps();
      this.activeAnimation();
    }
  }
}
